import { Component, Input } from '@angular/core';
import { IhmSystemStatusView } from './ihm-system-status-view.enum';

@Component({
  selector: 'app-ihm-system-status',
  templateUrl: './ihm-system-status.component.html',
  styleUrls: ['./ihm-system-status.component.scss']
})
export class IhmSystemStatusComponent {
  textOverFlow: string[] = ['APPROVED_AUTO_INJECTED', 'APPROVED_MANUAL_INJECTED', 'PENDING_MANUAL_INJECTION', 'PENDING_APPROVAL'];
  constructor() {}

  @Input() readonly status: IhmSystemStatusView = IhmSystemStatusView.IN_BUILD;

  isTextOverflow(text: string) {
    return this.textOverFlow.find(value => value === text);
  }
}
